import React from 'react'
import { IconCategory, IconType } from '@deepguide-ai/types'
// import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'
// import { AVAILABLE_ICONS } from '../emoji-picker/icon-data'
import { LucideIcon } from './LucideIcon'
import { getIconStyleClasses } from './utils'

export interface IconComponentProps {
  // New schema support
  icon?: string
  iconCategory?: IconCategory
  iconType?: IconType
  iconColor?: string | null
  // Legacy support (deprecated)
  iconName?: string
  // Common props
  size?: number
  className?: string
  style?: React.CSSProperties
  isStepIcon?: boolean
  strokeWidth?: number
}

export const IconComponent: React.FC<IconComponentProps> = ({
  // New schema props
  icon,
  iconCategory = 'LUCIDE',
  iconType = 'REGULAR',
  iconColor = '#3b82f6',
  // Legacy support
  iconName = 'File',
  // Common props
  size = 20,
  className,
  strokeWidth = 1,
  style,
}) => {
  // Use new schema or fallback to legacy
  const effectiveIcon = icon || iconName || 'sparkles'

  const effectiveCategory = iconCategory
  const effectiveType = iconType
  const effectiveColor = iconColor

  // Handle emoji vs lucide icon
  if (effectiveCategory === 'EMOJI') {
    return (
      <span
        style={{ fontSize: size, color: effectiveColor, ...style }}
        className={cn('inline-flex items-center justify-center', className)}
        aria-hidden='true'
      >
        {effectiveIcon}
      </span>
    )
  }

  const iconStyleClasses = getIconStyleClasses(effectiveType)

  return (
    <LucideIcon
      name={effectiveIcon}
      size={size}
      strokeWidth={strokeWidth}
      style={{ color: effectiveColor ?? undefined, ...style }}
      className={cn('transition-colors', iconStyleClasses, className)}
      aria-hidden='true'
    />
  )
}
